import type { FunctionComponent } from "react";

import { BTC } from "./BTC";
export { BTC } from "./BTC";

import { ETH } from "./ETH";
export { ETH } from "./ETH";

import { EETH } from "./EETH";
export { EETH } from "./EETH";

import { EZETH } from "./EZETH";
export { EZETH } from "./EZETH";

import { STETH } from "./STETH";
export { STETH } from "./STETH";

import { RETH } from "./RETH";
export { RETH } from "./RETH";

import { WETH } from "./WETH";
import { ARB } from "./ARB";
export { WETH } from "./WETH";

export * from "./ARB";

export const coins = {
	BTC: BTC,
	eETH: EETH,
	EETH,

	ETH,
	ARB,

	ezETH: EZETH,
	EZETH,

	rETH: RETH,
	RETH,

	wstETH: WETH,
	WETH,
	wETH: WETH,
	STETH: STETH,
	stETH: STETH,
};


export const coinMap = new Map<keyof typeof coins, FunctionComponent<any>>([
	["BTC", BTC],
	["stETH", STETH],
	["eETH", EETH],
	["rETH", RETH],
	["ezETH", EZETH],
]);
